export default "__VITE_ASSET__TUnvGl$9__"